import template from './auth.pug'

export default Vue.extend({
  name: 'google-ads-auth-index',
  template: template(),
  mounted() {
    const customerId = this.$route.query?.state
    if (customerId) {
      const {scope, code} = this.$route.query
      this.$router.push({
        name: 'customers-adwords',
        params: {id: customerId},
        query: {scope, code}
      })
    } else {
      window.close()
    }
  }
})
